interface CheckboxProps {
  disabled?: boolean;
  label?: string;
  error?: string;
  checked?: boolean;
  className?: string;
  onChange?: () => void;
}

export const Checkbox = ({
  checked,
  disabled,
  onChange,
  error,
  className,
}: CheckboxProps) => {
  return (
    <div className='flex items-center space-x-2 cursor-pointer w-full'>
      <input
        type='checkbox'
        className={`w-4 h-4 text-purple-normal bg-white border-gray-default rounded focus:ring-transparent ${className}`}
        checked={checked}
        disabled={!!disabled}
        onChange={onChange}
      />
      {error && <p className='text-red-500'>{error}</p>}
    </div>
  );
};
